module.exports = __webpack_public_path__ + "img/pro200.cfb0d525.png";